import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=2732f932&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
import style0 from "./Reports.vue?vue&type=style&index=0&id=2732f932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732f932",
  null
  
)

export default component.exports